import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card } from "@tellescope/design-system";
import { Button, LanguageSelector } from "@tellescope/ui";
import {
  useIsRegistrationDisabled,
  useLandingTitle,
  useLandingDescription,
} from "../../shared/store/portalSchemaStore";
import { AuthPageLayout } from "../components/AuthPageLayout";

/**
 * Landing page for unauthenticated endusers.
 * Shows welcome message with options to sign in or create an account.
 */
export const LandingPage: React.FC = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const isRegistrationDisabled = useIsRegistrationDisabled();
  const landingTitle = useLandingTitle();
  const landingDescription = useLandingDescription();

  const handleSignIn = () => {
    navigate("/login");
  };

  const handleCreateAccount = () => {
    navigate("/register");
  };

  return (
    <AuthPageLayout
      title={landingTitle || t("Welcome to the Patient Portal")}
      description={landingDescription || t("Sign in to access your health information")}
    >
      <Card.Body className="space-y-4">
        <Button onClick={handleSignIn} className="w-full" size="lg">
          {t("Sign In")}
        </Button>
        {!isRegistrationDisabled && (
          <Button onClick={handleCreateAccount} variant="outline" className="w-full" size="lg">
            {t("Create Account")}
          </Button>
        )}
      </Card.Body>

      <Card.Footer className="flex justify-center">
        <LanguageSelector />
      </Card.Footer>
    </AuthPageLayout>
  );
};
